import { setBusinessAccountAddressesArgsToParams } from 'data/api/transformers/arguments/set-business-account-addresses-args-to-params'
import { SetBusinessAccountAddressesArgs } from 'types/api/arguments/set-business-account-addresses-args'
import { BusinessAccountAddressesResp } from 'types/api/response/business-account-addresses-resp'

import { api } from './api'

export const setBusinessAccountAddresses = ({
  businessAccountId,
  ...args
}: SetBusinessAccountAddressesArgs) =>
  api.post<BusinessAccountAddressesResp>(
    `/business_accounts/${businessAccountId}/addresses`,
    setBusinessAccountAddressesArgsToParams(args),
  )
